import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
	selector: 'vtr-material-button',
	templateUrl: './material-button.component.html',
	styleUrls: ['./material-button.component.scss'],
})
export class MaterialButtonComponent implements OnInit {
	@Input() color = 'primary';
	@Input() label: string;
	@Input() tooltipText: string;
	@Input() tooltip = true;
	@Input() isDisabled = false;
	@Input() autoFocus = false;
	@Input() linkId: any;
	@Input() heightSize: mediumSize | largeSize | fillSize = 'md';
	@Input() widthSize: mediumSize | largeSize | fillSize = 'fill';
	@Input() buttonType: defaultButtonType | submitButtonType = 'button';
	@Input() overflowProperties = false;

	@Output() buttonClick = new EventEmitter<any>();
	public buttonClasses: string[] = [];
	public overFlow: 'hidden' | 'visible' = 'visible';
	public textOverFlow: 'clip' | 'ellipsis' = 'clip';

	private AUTOFOCUS_TIMEOUT = 200;

	constructor() {}

	ngOnInit() {
		this.initTooltipText();
		this.initButtonClasses();
		this.initButtonStyle();
		if (this.autoFocus) {
			setTimeout(() => {
				document.getElementById(this.linkId).focus();
			}, this.AUTOFOCUS_TIMEOUT);
		}
	}

	onButtonClick($event: any) {
		this.buttonClick.emit($event);
	}

	private initTooltipText() {
		if (!this.tooltipText) {
			this.tooltipText = this.label;
		}
	}

	private initButtonStyle() {
		if (this.overflowProperties) {
			this.overFlow = 'hidden';
			this.textOverFlow = 'ellipsis';
		}
	}

	private initButtonClasses() {
		this.buttonClasses.push(`vtr-material-button-height-${this.heightSize}`);
		this.buttonClasses.push(`vtr-material-button-width-${this.widthSize}`);
	}
}

type mediumSize = 'md';
type largeSize = 'lg';
type fillSize = 'fill';

type defaultButtonType = 'button';
type submitButtonType = 'submit';
